import clsx from "clsx";
import * as React from "react";
import { SIZES } from "@/enums/library";

type ContainerProps = {
  size?: Extract<SIZES, SIZES.SM | SIZES.BASE | SIZES.LG | SIZES.XL | SIZES.FULL>;
  children?: React.ReactNode;
  className?: string;
};

const Container: React.FC<ContainerProps> = ({
  size = SIZES.BASE,
  children,
  className,
}) => {
  return (
    <div
      className={clsx("mx-auto", className, {
        ["max-w-3xl"]: size === SIZES.SM,
        ["max-w-5xl"]: size === SIZES.BASE,
        ["max-w-7xl"]: size === SIZES.LG,
        ["max-w-9xl"]: size === SIZES.XL,
        ["max-w-full"]: size === SIZES.FULL,
      })}
    >
      {children}
    </div>
  );
};

export default Container;
